import { memo } from 'react';
import styled from 'styled-components';

import Logo from '@components/Logo/Logo';

const Wrapper = styled.div`
  display: flex;
  margin-bottom: 3rem;
`;

const Container = styled.div`
  color: var(--theme-color-always-light);
  display: inline-block;
  margin: 0 auto;
  position: relative;
  text-align: center;
  z-index: 1;

  &:before,
  &:after {
    background: var(--theme-color-section-home);
    content: ' ';
    height: calc(100% - 25px);
    left: 0;
    position: absolute;
    top: 25px;
    width: 100%;
  }

  &:before {
    transform: skew(-15deg) rotate(-2deg);
    z-index: -1;
  }

  &:after {
    transform: skew(20deg) rotate(4deg);
    z-index: -2;
  }
`;

const Label = styled.div`
  font-size: 2.6rem;
  padding: 0 1rem 0.5rem;
`;

type RecommendedProps = {
  siteTitle: string;
};

const Recommended = ({ siteTitle }: RecommendedProps) => {
  return (
    <Wrapper>
      <Container>
        <Logo size="tiny" title={siteTitle} />
        <Label>Recommended</Label>
      </Container>
    </Wrapper>
  );
};

export default memo(Recommended);
